var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowsHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#arrows--horizontal_svg__clip0_61530_7442)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.557 19.942L5.872 17.25H21v-1.5H5.872l2.685-2.693L7.5 12 3 16.5 7.5 21l1.057-1.058zM21 7.5L16.5 3l-1.057 1.058 2.685 2.692H3v1.5h15.128l-2.685 2.693L16.5 12 21 7.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrows--horizontal_svg__clip0_61530_7442"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgArrowsHorizontal;